<template>

  <base-display-widget :iteminfo="iteminfo" v-bind="$attrs" v-on="$listeners"
                       class="bg-white"
                       style="width: 373px;">
    <img :src="getItemPic()"
         class="w-full"
         style="cursor: pointer;vertical-align: top"/>
  </base-display-widget>
</template>

<script>
import BaseDisplayWidget from '../base/BaseDisplayWidget'
import RatioDiv from '../../common/RatioDiv'

export default {
  name: 'HotZoneDisplayWidget',
  components: {
    BaseDisplayWidget,
    RatioDiv,
  },
  props: {
    iteminfo: Object
  },

  data () {
    return {}
  },
  computed: {
    getshowDataList () {
      return this.iteminfo.dataList
    },
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
    },
    getItemPic () {
      let src = require('../../../assets/tempmenu/img_picture_single.png')
      if (this.iteminfo.config.datalist && this.iteminfo.config.datalist.length) {
        if (this.iteminfo.config.datalist[0].picurl) {
          src =this.iteminfo.config.datalist[0].picurl
        }
      }
      return src
    },
  }
}
</script>

<style lang="scss" scoped>
</style>
